import React from "react";
import { useLocation } from "react-router-dom";
import RootMembership from "container/membership/RootMembership";
import GatewayCheckpoint from "container/common/GatewayCheckpoint";
import AppUpdateCheckpoint from "container/common/AppUpdateCheckpoint";
import { getQueryObjFromUrl, getEssentialUrl } from "lib/urlQueryParser";

function MembershipPage(props) {
  const location = useLocation();
  const query = getQueryObjFromUrl(location.search);

  return (
    <AppUpdateCheckpoint>
      <GatewayCheckpoint
        type={"replace"}
        url={getEssentialUrl({ type: "membership" })()}
      >
        <RootMembership query={query} />
      </GatewayCheckpoint>
    </AppUpdateCheckpoint>
  );
}

export default MembershipPage;
